
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M12 5.00003V2.21003C12 1.76003 11.46 1.54003 11.15 1.86003L7.35003 5.65003C7.15003 5.85003 7.15003 6.16003 7.35003 6.36003L11.14 10.15C11.46 10.46 12 10.24 12 9.79003V7.00003C15.73 7.00003 18.68 10.42 17.86 14.29C17.39 16.56 15.55 18.39 13.29 18.86C9.72003 19.61 6.54003 17.16 6.06003 13.85C5.99003 13.37 5.57003 13 5.08003 13C4.48003 13 4.00003 13.53 4.08003 14.13C4.70003 18.52 8.88003 21.77 13.61 20.85C16.73 20.24 19.24 17.73 19.85 14.61C20.84 9.48003 16.94 5.00003 12 5.00003ZM9.56003 13.49H10.01C10.22 13.49 10.38 13.44 10.49 13.33C10.6 13.22 10.65 13.08 10.65 12.9C10.65 12.82 10.64 12.75 10.61 12.68C10.58 12.61 10.55 12.56 10.5 12.51C10.45 12.46 10.39 12.42 10.32 12.4C10.25 12.38 10.16 12.36 10.07 12.36C9.99003 12.36 9.92003 12.37 9.85003 12.39C9.78003 12.41 9.72003 12.44 9.67003 12.49C9.62003 12.54 9.58003 12.58 9.55003 12.64C9.52003 12.7 9.50003 12.77 9.50003 12.84H8.65003C8.65003 12.66 8.69003 12.5 8.76003 12.36C8.83003 12.22 8.93003 12.09 9.06003 11.99C9.19003 11.89 9.33003 11.81 9.50003 11.76C9.67003 11.71 9.85003 11.68 10.04 11.68C10.25 11.68 10.45 11.71 10.63 11.76C10.81 11.81 10.96 11.89 11.09 11.99C11.22 12.09 11.32 12.22 11.39 12.37C11.46 12.52 11.5 12.7 11.5 12.9C11.5 12.99 11.49 13.08 11.46 13.17C11.43 13.26 11.39 13.34 11.33 13.42C11.27 13.5 11.21 13.57 11.13 13.64C11.05 13.71 10.96 13.76 10.85 13.81C11.09 13.9 11.27 14.02 11.39 14.2C11.51 14.38 11.57 14.58 11.57 14.81C11.57 15.01 11.53 15.19 11.45 15.34C11.37 15.49 11.27 15.63 11.13 15.73C10.99 15.83 10.84 15.92 10.65 15.97C10.46 16.02 10.27 16.05 10.05 16.05C9.87003 16.05 9.69003 16.03 9.52003 15.98C9.35003 15.93 9.19003 15.86 9.06003 15.75C8.93003 15.64 8.81003 15.52 8.73003 15.37C8.65003 15.22 8.61003 15.03 8.61003 14.82H9.46003C9.46003 14.9 9.48003 14.97 9.51003 15.04C9.54003 15.11 9.58003 15.16 9.64003 15.21C9.70003 15.26 9.76003 15.3 9.84003 15.32C9.92003 15.34 10 15.36 10.09 15.36C10.19 15.36 10.28 15.35 10.36 15.32C10.44 15.29 10.51 15.25 10.56 15.2C10.61 15.15 10.66 15.09 10.69 15.02C10.72 14.95 10.73 14.87 10.73 14.78C10.73 14.67 10.71 14.57 10.68 14.49C10.65 14.41 10.6 14.34 10.54 14.29C10.48 14.24 10.41 14.2 10.32 14.18C10.23 14.16 10.14 14.14 10.03 14.14H9.56003V13.49ZM15.3 14.24C15.3 14.56 15.27 14.84 15.2 15.06C15.13 15.28 15.03 15.48 14.91 15.63C14.79 15.78 14.63 15.89 14.46 15.96C14.29 16.03 14.09 16.06 13.87 16.06C13.65 16.06 13.46 16.03 13.28 15.96C13.1 15.89 12.95 15.78 12.82 15.63C12.69 15.48 12.59 15.29 12.52 15.06C12.45 14.83 12.41 14.56 12.41 14.24V13.5C12.41 13.18 12.44 12.9 12.51 12.68C12.58 12.46 12.68 12.26 12.8 12.11C12.92 11.96 13.08 11.85 13.25 11.78C13.42 11.71 13.62 11.68 13.84 11.68C14.06 11.68 14.25 11.71 14.43 11.78C14.61 11.85 14.76 11.96 14.89 12.11C15.02 12.26 15.12 12.45 15.19 12.68C15.26 12.91 15.3 13.18 15.3 13.5V14.24ZM14.45 13.38C14.45 13.19 14.44 13.03 14.41 12.9C14.38 12.77 14.34 12.67 14.29 12.59C14.24 12.51 14.18 12.45 14.1 12.42C14.02 12.39 13.94 12.37 13.85 12.37C13.76 12.37 13.67 12.39 13.6 12.42C13.53 12.45 13.46 12.51 13.41 12.59C13.36 12.67 13.32 12.77 13.29 12.9C13.26 13.03 13.25 13.19 13.25 13.38V14.35C13.25 14.54 13.26 14.7 13.29 14.83C13.32 14.96 13.36 15.07 13.41 15.15C13.46 15.23 13.52 15.29 13.6 15.32C13.68 15.35 13.76 15.37 13.85 15.37C13.94 15.37 14.03 15.35 14.1 15.32C14.17 15.29 14.24 15.23 14.29 15.15C14.34 15.07 14.38 14.96 14.4 14.83C14.43 14.7 14.44 14.54 14.44 14.35V13.38H14.45Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-replay-30`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconReplay30

    ```js
    <b-new-b-icon-replay-30 />
    ```
</docs>


